<ui-dialog size="small" [open]="openDialog" header="applicant-tracker.createInterview" (closing)="onCancel()">
    <div class="subtitle">{{ 'applicant-tracker.messages.interview.startFromAnExistingInterview' | appTranslate }}</div>
    <div class="app-grid padding-3 margin-right-5 margin-left-1">
        <div class="columns-12">
            <mat-radio-group class="vertical" name="createAction" [(ngModel)]="selectedCreateAction" required>
                <mat-radio-button value="fromExistingInterview">{{
                    'applicant-tracker.basedOnAnExistingInterview' | appTranslate
                }}</mat-radio-button>
                <mat-form-field
                    class="no-top-padding padding-top-1 margin-left-3"
                    *ngIf="selectedCreateAction === 'fromExistingInterview'"
                >
                    <mat-select
                        type="text"
                        placeholder="{{ 'applicant-tracker.selectAPreviousInterview' | appTranslate }}"
                        name="selectedExistingInterview"
                        [(ngModel)]="selectedExistingInterview"
                    >
                        <mat-option *ngFor="let interview of existingInterviews" [value]="interview">
                            {{ interview.name }}
                            <span class="for-job-posting">
                                {{
                                    {
                                        key: 'applicant-tracker.forTitle',
                                        params: { title: interview.jobPosting?.title },
                                    } | appTranslate
                                }}</span
                            >
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-radio-button value="fromScratch" class="margin-top-2 margin-bottom-2">{{
                    'applicant-tracker.fromScratch' | appTranslate
                }}</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button
            type="primary"
            [disabled]="
                selectedCreateAction === jobPostingCreateInterviewActions.fromExistingInterview &&
                !selectedExistingInterview
            "
            (click)="onCreate()"
            >{{ 'create' | appTranslate }}</ui-button
        >
    </ui-dialog-footer>
</ui-dialog>
